export function ComponentLoading() {
    return (
        <div className='component-loading'>
            <div className='bounce1'></div>
            <div className='bounce2'></div>
            <div className='bounce3'></div>
        </div>
    );
}
